import { post, get, getFrom } from "@/axios";


//获取附加项信息
export const getAdditionalItemsInfo = function (params) {
  return get(`/order/customer/platformOrderItem/getAdditionalItemsInfo`, params)
}
//获取附加项信息_多条
export const listAdditionalItemsInfo = function (params) {
  return get(`/order/customer/platformOrderItem/listAdditionalItemsInfo`, params)
}
//获取水洗标
export const getProductMaterial = function (params) {
  return get(`/order/customer/platformOrderItem/getProductMaterial`, params)
}
//获取质检信息
export const selectSpecialCheckInfo = function (params) {
  return get(`/order/customer/platformOrderItem/selectSpecialCheckInfo`, params)
}
//获取水洗标公司信息
export const getWashedlabelWarehouse = function (params) {
  return get(`/customer/additional/getWashedlabelWarehouse`, params)
}
//获取水洗标商品信息
export const byProductSkuList = function (params) {
  return post(`/goods/product/skus/byProductSkuList/feign`, params)
}
//获取水洗标商品信息-oem
export const byProductSkuList_OEM = function (params) {
  return post(`/order/searchSourceOrder/sku/list/backend`, params)
}
//获取b2b水洗标shopProductSku
export const queryCustomerProductMsku = function (params) {
  return post(`/order/shop/product/sku/queryCustomerProductMsku`, params)
}
//通过直行便订单号查询api订单下的sku
export const selectApiSku = function (params) {
  return get(`/api/thirdShopOrder/queryThirdShopItemSku`, params)
}
//查询辅料库位
export const getIngredientsBatch = function (params) {
  return post(`/wms/pkg/getIngredientsBatch`, params)
}
//获取附加项信息_次转正过渡
export const getAdditionalItems = function (params) {
  return get(`/wms/inboundOrderAddition/getAdditionalItems`, params)
}
//打印水洗标操作日志
export const printLabelRecordLog = function (params) {
  return get(`/wms/pkg/printLabelRecord`, params)
}
//提交新品测量结果
export const editSize = function (params) {
  return post(`/wms/measure/editSize`, params)
}
//打印水洗标材质
export const getSkuMaterials = function (params) {
  return get(`/wms/pkg/getSkuMaterials`, params)
}

//仓库打印水洗标获取水洗标相关信息
export const getWashedlabelInfo = function (params) {
  return get(`/order/customer/platformOrderItemAddition/getWashedlabelInfo`, params)
}

//仓库异常上报客户时，检查此批次包是否上报过此类型的异常
export const promptCheck = function (params) {
  return post(`/wms/pkg/promptCheck`, params)
}
// 获取次品重拍次数
export const orderRemakeCount = function (params) {
  return get('/wms/pkg/orderRemakeCount', params)
}


export const listSpecialInboundRequirement = function (params) {
  return post(`/order/customer/platformOrderItem/v2/listSpecialInboundRequirement`, params)
}
